import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Input from '../../components/Input'
import Paragraph from '../../components/Paragraph'
import Row from '../../components/Row'
import formatPhoneNumber from '../../utils/formatPhoneNumber'
import request from '../../utils/request'

@observer
export default class UserPhone extends Component {
  @observable error = false
  @observable loading = false
  @observable success = false
  @observable changed = false
  @observable step = 1
  oldPhone = ''

  @observable
  fields = {
    phone: '',
    code: '',
  }

  @action
  setInitialFields = fields => {
    this.fields.phone = formatPhoneNumber(fields.phone)
    this.oldPhone = formatPhoneNumber(fields.phone)
  }

  @action
  setField = event => {
    this.error = false
    this.success = false
    this.changed = true

    if (event.target.name === 'phone') {
      this.fields.phone = formatPhoneNumber(event.target.value)
    } else {
      this.fields[event.target.name] = event.target.value
    }
  }

  @action
  setLoading = () => {
    this.loading = true
    this.error = false
    this.success = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }

  @action
  setSuccess = () => {
    this.loading = false
    this.error = false
    this.success = true
    this.changed = false
    this.step = 1
    this.fields.code = ''
    this.oldPhone = this.fields.oldPhone
  }

  @action
  cancel = () => {
    this.loading = false
    this.error = false
    this.success = false
    this.changed = false
    this.step = 1
    this.fields.code = ''
    this.fields.oldPhone = this.oldPhone
  }

  @action
  openStep2 = () => {
    this.step = 2
    this.loading = false
  }

  submit1 = async event => {
    event.preventDefault()
    this.setLoading()

    const res = await request('/api/changePhone/step1', {
      phone: this.fields.phone.replace(/\D/g, ''),
    })

    if (res.success) {
      this.openStep2()
    } else {
      this.setError()
    }
  }

  submit2 = async event => {
    event.preventDefault()
    this.setLoading()
    const res = await request('/api/changePhone/step2', { code: this.fields.code })

    if (res.success) {
      this.setSuccess()
    } else {
      this.setError()
    }
  }

  componentDidMount() {
    const { fields } = this.props
    this.setInitialFields(fields)
  }

  render() {
    return (
      <Card>
        <form onSubmit={this.step === 2 ? this.submit2 : this.submit1}>
          {this.error && <Card.ErrorMessage />}
          {this.success && <Card.SavedMessage />}
          <Card.Pad>
            {this.step === 1 &&
              <Input
                name="phone"
                label="titles.mobilePhone"
                disabled={this.loading}
                value={this.fields.phone}
                onChange={this.setField}
              />
            }
            {this.step === 2 &&
              <Fragment>
                <Paragraph str="prose.authCodeSentPhone" />
                <Input
                  name="code"
                  label="titles.authCode"
                  disabled={this.loading}
                  value={this.fields.code}
                  onChange={this.setField}
                />
              </Fragment>
            }
          </Card.Pad>
          {this.step === 1 && this.changed &&
            <Fragment>
              <Card.Divider />
              <Card.Pad>
                <Button
                  color="blue"
                  disabled={this.loading}
                  str="titles.save"
                  type="submit"
                />
              </Card.Pad>
            </Fragment>
          }
          {this.step === 2 &&
            <Fragment>
              <Card.Divider />
              <Card.Pad>
                <Row>
                  <Row.Cell>
                    <Button
                      color="gray"
                      disabled={this.loading}
                      str="titles.cancel"
                      onClick={this.cancel}
                    />
                  </Row.Cell>
                  <Row.Cell>
                    <Button
                      color="blue"
                      disabled={this.loading}
                      str="titles.verify"
                      type="submit"
                    />
                  </Row.Cell>
                </Row>
              </Card.Pad>
            </Fragment>
          }
        </form>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Profile/UserPhone.js